module.exports = __webpack_public_path__ + "img/dongfanyuanlib.26ce03bf.jpg";